import classnames from 'classnames';
import React from 'react';
import { Json } from '../../types';
import IconMenu from '../IconMenu/IconMenu';
import { ModelCard } from '../ModelCard/ModelCard';
import type { VirtualGalleryProps } from './VirtualGallery';
import { Icon, Id, Item } from './VirtualGallery.style';

export type GalleryItemProps = VirtualGalleryProps & {
  style: React.CSSProperties;
  item: Json;
  isHovered: boolean;
  onHover: (id: string) => void;
  children?: React.ReactNode;
  hideId?: boolean;
};

export function GalleryItem(props: GalleryItemProps) {
  const { style, item, small, itemActions = [], baseImageUrl, isHovered } = props;
  const { id } = item;

  const className = classnames('GalleryItem item', {
    small,
  });

  function renderIconMenu() {
    if (itemActions.length === 0 || !isHovered) return null;

    return (
      <Icon>
        <IconMenu actions={itemActions} onAction={props.onAction} itemId={item.id} />
      </Icon>
    );
  }

  function onClick() {
    props.onClick(item);
  }

  function renderId() {
    if (props.hideId) return;
    return <Id className='id'>{id}</Id>;
  }

  const Cmp = props.children ?? ModelCard;

  return (
    <Item className={className} style={{ ...style }} onMouseOver={() => props.onHover(item.id)}>
      {renderId()}
      <Cmp
        model={item as any}
        baseImageUrl={baseImageUrl}
        personal
        containImage
        small={small}
        onClick={onClick}
      />
      {renderIconMenu()}
    </Item>
  );
}
